import { render } from "./ReviewsAction.vue?vue&type=template&id=5003835d&ts=true"
import script from "./ReviewsAction.vue?vue&type=script&lang=ts"
export * from "./ReviewsAction.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__